import * as React from "react";
import { FilterList, palette } from "@conserveit/blocks";
import { RuleItem } from "./RuleItem";
import { BoxContent } from "../ProjectSettings.styles";
import { RuleSetting, RuleListSetting } from "../../../context/settings/types";
import { useRuleSettings } from "../hooks/useRuleSettings";
import { InlineAction, ListSection } from "./ToggleList.styles";

interface Props {
  ruleList: RuleListSetting[];
  selectedRule?: RuleSetting;
  onRuleSelect(selected: RuleSetting): void;
  activeProject: string;
}

const RulesBox = React.memo<Props>(
  (props) => {
    const { ruleList, onRuleSelect, selectedRule } = props;
    const {
      handleCheck,
      checked,
      propagated,
      updateActive,
      clearAll,
      selectAll,
    } = useRuleSettings();

    if (ruleList.length < 1) return <BoxContent />;

    return (
      <FilterList items={ruleList} filterKey="filterable" filterDelay={500}>
        {({ visible }) => {
          const rules = visible.reduce(
            (acc: any, rule: RuleSetting) => {
              // tslint:disable-next-line: strict-type-predicates
              if (propagated[rule.rule.id] !== undefined) {
                acc.active.push(rule);
              } else {
                acc.inactive.push(rule);
              }
              return acc;
            },
            { active: [], inactive: [] }
          );

          return (
            <BoxContent onMouseLeave={updateActive}>
              <ListSection style={{ background: palette.neutral2 }}>
                {rules.active.length > 0 && (
                  <InlineAction onClick={clearAll(rules.active)}>
                    Clear all
                  </InlineAction>
                )}
                {rules.active.map((rule: RuleSetting) => {
                  return (
                    <RuleItem
                      key={rule.rule.id}
                      rule={rule}
                      onRuleChecked={handleCheck}
                      onRuleSelect={onRuleSelect}
                      isActive={
                        selectedRule !== undefined &&
                        rule.rule.id === selectedRule.rule.id
                      }
                      isChecked
                    />
                  );
                })}
              </ListSection>
              <ListSection>
                {rules.inactive.length > 0 && (
                  <InlineAction onClick={selectAll(rules.inactive)}>
                    Select all
                  </InlineAction>
                )}
                {rules.inactive.map((rule: RuleSetting) => {
                  return (
                    <RuleItem
                      key={rule.rule.id}
                      rule={rule}
                      onRuleChecked={handleCheck}
                      onRuleSelect={onRuleSelect}
                      isActive={
                        selectedRule !== undefined &&
                        rule.rule.id === selectedRule.rule.id
                      }
                      // tslint:disable-next-line: strict-type-predicates
                      isChecked={checked[rule.rule.id] !== undefined}
                    />
                  );
                })}
              </ListSection>
            </BoxContent>
          );
        }}
      </FilterList>
    );
  },
  (p, n) =>
    p.activeProject === n.activeProject && p.selectedRule === n.selectedRule
);

export default RulesBox;
